import { render, staticRenderFns } from "./CompanyPageLanding.vue?vue&type=template&id=6e0a95e6&scoped=true&"
import script from "./CompanyPageLanding.vue?vue&type=script&lang=js&"
export * from "./CompanyPageLanding.vue?vue&type=script&lang=js&"
import style0 from "./CompanyPageLanding.vue?vue&type=style&index=0&id=6e0a95e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0a95e6",
  null
  
)

export default component.exports